import { PORTRAIT_IMG } from "../../lib/site";

const BULLETS = [
  { t: "Human Underwriting", d: "No opaque algorithms. Every file receives a personal review by a senior underwriter." },
  { t: "Radical Transparency", d: "Every rate, every fee, every clause — disclosed in plain English before you sign." },
  { t: "Federally-Aligned Compliance", d: "Full adherence to Reg Z, GLBA, and CCPA requirements. Your data belongs to you." },
  { t: "Concierge Service", d: "You will speak to the same advisor from application to disbursement — every time." },
];

export default function AboutSection() {
  return (
    <section id="about" className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="relative">
            <img src={PORTRAIT_IMG} alt="Portrait of a business professional" className="h-[520px] w-full object-cover" />
            <div className="absolute -bottom-6 -right-6 hidden border border-[#D4AF37]/60 bg-[#0A1128] px-6 py-5 lg:block">
              <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Since</div>
              <div className="font-serif text-3xl">2014</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pl-8">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">About Lending Loan USA</div>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight sm:text-5xl">
            A private lender for people who read the fine print.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">
            We built Lending Loan USA because the largest banks stopped treating their clients like clients.
            Every application here is reviewed by a real underwriter, protected by the same encryption used by
            federal institutions, and delivered with the kind of quiet precision that defined American finance
            a century ago.
          </p>
          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {BULLETS.map((b) => (
              <div key={b.t} className="border border-white/10 bg-white/[0.02] p-6">
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">{b.t}</div>
                <p className="mt-3 text-sm leading-relaxed text-white/70">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
